import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Card, CardBody, Input, Label,Button } from 'reactstrap';
import { toast } from 'react-toastify';
import { updateoptout, oneoptout,getOptOut } from '../../../Redux/Actions/Mask/Mask';


import Loader from '../../../components/common/Loader';


const EditOutput = ({ optout, updateoptout, oneoptout, id ,toggle,getOptOut}) => {
  const [title, settile] = useState('');
  const [message, setmessage] = useState('');



  console.log("optout=================================",optout)
  // useEffect(() => {
  //   oneoptout(id);
  //   if (optout != null && optout._id == id) {
  //     settile(optout.title);
  //     setmessage(optout.message);
  //   }
  // }, [optout != null]);

//   useEffect(() => {
//   oneoptout(id);
// }, []);

// useEffect(() => {
//   if (optout && optout._id === id) {
//     settile(optout.title);
//     setmessage(optout.message);
//   }
// }, [optout, id]);



  useEffect(() => {
  oneoptout(id);
}, []);

useEffect(() => {
  if (optout && optout._id === id) {
    settile(optout.title);
    setmessage(optout.message);
  }
}, [optout, id]);






  const updateoptoutss = () => {
       const optOutKeywords = ['STOP', 'STOPALL', 'UNSUBSCRIBE', 'CANCEL', 'END', 'QUIT' ,'START', 'YES', 'UNSTOP'];
      const messageUpper = message.toUpperCase();
    
      const containsKeyword = optOutKeywords.some(keyword => messageUpper.includes(keyword));
    
      if (!containsKeyword) {
        toast.error("The message must contain at least one opt-out/re-subscribe keyword.");
        return;
      }
    
    updateoptout({ title, message }, id);
    getOptOut()
    toggle()
  };


  if (optout == null) {
    return <Loader />;
  } else {
    return (
      <Row className="justify-content-center">
        <Col md={12}>
          
          {/* <Row>
  <Col md={12}>
    <Label style={{ textAlign: 'left', display: 'block' }}>Title</Label>
    <Input
      type="text"
      value={title}
      style={{ textAlign: 'left' }}
      onChange={e => {
        settile(e.target.value);
      }}
      placeholder="Title"
    />
  </Col>

  <Col md={12} className="pt-4">
    <Label style={{ textAlign: 'left', display: 'block' }}>Message</Label>
    <Input
      type="text"
      value={message}
      style={{ textAlign: 'left' }}
      onChange={e => {
        setmessage(e.target.value);
      }}
      placeholder="Message"
    />
  </Col>

  <Col md={12} className="p-4" style={{ textAlign: 'right' }}>
    <div
      className="btn btn-sm btn-primary"
      onClick={updateoptoutss}
    >
      Save
    </div>
  </Col>
</Row> */}


    <div
      style={{
        backgroundColor: '#fff3cd',
        border: '1px solid #ffeeba',
        padding: '15px',
        borderRadius: '5px',
        color: '#856404',
        fontWeight: 'bold',
        marginBottom: '20px',
        fontSize: '14px',
        boxShadow: '0 2px 5px rgba(0,0,0,0.1)'
      }}
    >
      <p style={{ marginBottom: '5px' }}>
        ⚠️ <strong>Important:</strong> Only the following keywords are supported by Mergecall for opt-out and resubscribe.
      </p>
      <p style={{ marginBottom: '5px' }}>
        <strong>To Opt-Out:</strong> STOP, STOPALL, UNSUBSCRIBE, CANCEL, END, QUIT
      </p>
      <p style={{ marginBottom: '0' }}>
        <strong>To Re-subscribe:</strong> START, YES, UNSTOP
      </p>
    </div>


      <Row>
  <Col md={12}>
    <Label style={{ textAlign: 'left', display: 'block' }}>Title</Label>
    <Input
      type="text"
      value={title}
      style={{ textAlign: 'left' }}
      onChange={e => {
        settile(e.target.value);
      }}
      placeholder="Title"
    />
  </Col>

  <Col md={12} className="pt-4">
    <Label style={{ textAlign: 'left', display: 'block' }}>Message</Label>
    <Input
      type="text"
      value={message}
      style={{ textAlign: 'left' }}
      onChange={e => {
        setmessage(e.target.value);
      }}
      placeholder="Message"
    />
  </Col>

  <Col md={12} className="p-4" style={{ textAlign: 'right' }}>
    <Button
      className="btn btn-sm btn-primary"
      onClick={updateoptoutss}
       disabled={title.trim() === '' || message.trim() === ''}
    >
      Save
    </Button>
  </Col>
</Row>

        </Col>
      </Row>
    );
  }
};
const mapStateTOProps = state => ({
  optout: state.bulk.ooptout
});
export default connect(
  mapStateTOProps,
  { updateoptout, oneoptout,getOptOut }
)(EditOutput);
